














































import { defineComponent, computed } from '@vue/composition-api'
import { useTournament } from '../../reactive/tournament.state'

export default defineComponent({
  setup(props, { root }) {
    const {
      tournament,
      isOpen,
      isPlanable,
      isPlayable,
      isClosed,
      isAdmin,
    } = useTournament()

    const hash = computed(() => root.$route.params.hash)

    return {
      hash,
      tournament,
      isOpen,
      isPlanable,
      isPlayable,
      isClosed,
      isAdmin,
    }
  },
})
